export default __webpack_public_path__ + "static/media/originball.8852df42.png";